<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 pt-0 print:hidden"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.compact"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="mb-4 mt-3 flex h-20 items-center justify-center">
      <img class="w-20" src="images/logo/logo-temporal-fichaje.png" alt="Logo image" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card fixed top-0 z-50 flex h-16 w-full items-center bg-white px-4 shadow md:left-0 md:px-6 dark:border-b dark:bg-gray-900 dark:shadow-none print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>

    <!-- Title -->
    <div class="absolute left-1/2 -translate-x-1/2 text-center w-[72vw] sm:w-[320px] max-w-[320px] min-w-[200px]">
      <div class="flex flex-col items-center overflow-hidden">
        <span class="text-xs">LABORYS</span>
        @if (canSwitchEnterprise) {
          <button
            type="button"
            class="flex w-full items-center justify-center gap-0.5 text-sm sm:text-lg font-semibold leading-tight focus:outline-none"
            [matMenuTriggerFor]="enterpriseSwitchMenu"
            [disabled]="isSwitching"
            (menuOpened)="enterpriseFilter = ''"
          >
            <span class="truncate">{{ formattedEnterpriseName || 'EMPRESA' }}</span>
            <mat-icon class="!text-base leading-none flex-shrink-0" [class.opacity-40]="isSwitching">expand_more</mat-icon>
          </button>
        } @else {
          <h1 class="text-base sm:text-lg font-semibold truncate w-full text-center">
            {{ formattedEnterpriseName || 'EMPRESA' }}
          </h1>
        }
      </div>
    </div>

    <!-- Componentes a la derecha -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <app-theme-toggle></app-theme-toggle>
      <app-pwa-install></app-pwa-install>
      <user></user>
    </div>
  </div>

  <!-- Enterprise switcher menu -->
  <mat-menu #enterpriseSwitchMenu="matMenu" class="!w-[72vw] sm:!w-[320px] !max-w-[320px] !min-w-[200px]">
    <div class="px-3 pt-2 pb-1" (click)="$event.stopPropagation()">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
        <mat-icon matPrefix class="mr-1">search</mat-icon>
        <input matInput [(ngModel)]="enterpriseFilter" placeholder="Buscar empresa..." />
      </mat-form-field>
    </div>
    @for (enterprise of filteredSwitchableEnterprises; track enterprise.id) {
      <button mat-menu-item (click)="onSwitchEnterprise(enterprise)">
        {{ enterprise.name }}
      </button>
    }
    @if (!filteredSwitchableEnterprises.length) {
      <button mat-menu-item disabled>Sin resultados</button>
    }
  </mat-menu>

  <!-- Content -->
  <div class="flex flex-auto flex-col pt-16">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
  <!-- Footer -->
  <div
    class="bg-card flex h-14 w-full items-center justify-between border-t px-4 md:px-6 dark:bg-transparent print:hidden"
  >
    <span class="text-secondary text-base font-medium">
      Ternary Software S.L.
      <button mat-icon-button (click)="toggleVersionInfo()" class="ml-1 -mr-2 -my-1">
        <mat-icon class="text-sm">info</mat-icon>
      </button>
      @if (showVersionInfo) {      
        <span class="ml-1 text-xs opacity-70">v{{appVersion}}</span>
    }
    </span>
    <a routerLink="/faq" class="text-primary hover:text-primary-600 text-sm font-medium transition-colors duration-200 underline">
      AYUDA
    </a>
  </div>
</div>
